import React from 'react';

import QuestionSingleChoice from '../QuestionSingleChoice';
import QuestionMultiChoice from '../QuestionMultiChoice';
import QuestionDropDown from '../QuestionDropDown';
import QuestionDragAndDrop from '../QuestionDragAndDrop';
import QuestionFillBlanks from '../QuestionFillBlanks';

import { TYPE2COMPONENT } from '../../constants/questionTypes';

const Components = {
  QuestionSingleChoice,
  QuestionMultiChoice,
  QuestionDropDown,
  QuestionDragAndDrop,
  QuestionFillBlanks,
};

export const QuestionDisplay = (props) => {
  let Component = Components[ TYPE2COMPONENT[props.question.type] ];
  return (<Component { ...props } />);
};

export default QuestionDisplay;